const UPDATES = [
  { date: '2026.08.01', title: '《犯罪都市4》高清中字上线，马东锡硬核回归', tag: '新片速递' },
  { date: '2026.07.31', title: '《你想活出怎样的人生》宫崎骏最新动画电影全网首播', tag: '热门推荐' },
  { date: '2026.07.30', title: '《破墓》韩国现象级恐怖片中文字幕版更新', tag: '新片速递' },
  { date: '2026.07.29', title: '日本动画《鬼灭之刃 无限城篇》剧场版资源已同步', tag: '动画更新' },
  { date: '2026.07.28', title: '韩国悬疑剧《杀人者的购物中心》全集高清上线', tag: '剧集更新' },
  { date: '2026.07.27', title: '《首尔之春》韩国年度票房冠军高清修复版发布', tag: '经典修复' },
  { date: '2026.07.26', title: '日本纯爱电影《余生那些年》催泪上线，好评如潮', tag: '新片速递' },
  { date: '2026.07.25', title: '片库新增150部经典日韩电影，涵盖多种题材', tag: '片库扩充' },
];

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">最新动态</h2>
        <p className="text-sm text-foreground-500 mb-8">片库每日更新，精彩永不错过</p>
        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300 hidden sm:block"></div>
          <div className="space-y-0">
            {UPDATES.map((item, i) => (
              <div key={i} className="flex gap-4 py-4 group">
                <div className="hidden sm:flex flex-col items-center pt-1">
                  <div className={`w-[10px] h-[10px] rounded-full border-2 flex-shrink-0 ${
                    i === 0 ? 'bg-primary-500 border-primary-500' : 'bg-background-50 border-background-300 group-hover:border-primary-400 transition-colors'
                  }`}></div>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                    <span className={`text-xs px-2 py-0.5 rounded-full whitespace-nowrap font-medium ${
                      item.tag === '新片速递' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '热门推荐' ? 'bg-accent-100 text-accent-700' :
                      'bg-secondary-100 text-secondary-700'
                    }`}>{item.tag}</span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 leading-relaxed group-hover:text-foreground-950 transition-colors">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}